<!--
  授权范围详情
-->
<template>
  <div class="authorized-scope">
    <div class="inner_center">
      <h2>授权范围详情</h2>
      <div class="members-package">
        <i class="icon_vip-member"/>
        <div class="authorization-scoped-wrap">
          <!-- 授权范围 -->
          <div class="authorization-scoped">
            授权范围
          </div>
          <!-- 权益保障 -->
          <div class="rights-and-interests authorization-item">
            <div class="title">权益保障</div>
            <ul>
              <li v-for="vo in info.rightsAndInterests.list" :key=" 'right' + vo.name ">
                <div class="name">{{ vo.name }}</div>
                <div class="desc" v-html="vo.desc">{{ }}</div>
              </li>
            </ul>
          </div>
          <!-- 线上用途 -->
          <div class="online-use authorization-item">
            <div class="title">
              线上用途 <br>
            </div>
            <ul>
              <li v-for="vo in info.onlineUse.list" :key=" 'online-use' + vo.name ">
                <div class="name">{{ vo.name }}</div>
                <div class="desc">{{ vo.desc }}</div>
              </li>
            </ul>
          </div>
          <div class="offline-use authorization-item">
            <div class="title" style=" border-radius: 0 0 0 20px">
              广告宣传 <br>
            </div>
            <ul>
              <li v-for="vo in info.advertising.list" :key=" 'offline-use' + vo.name ">
                <div class="name">{{ vo.name }}</div>
                <div class="desc" v-html="vo.desc">{{ }}</div>
              </li>
            </ul>
          </div>

          <!-- 线下用途 -->
          <div class="offline-use authorization-item">
            <div class="title" style=" border-radius: 0 0 0 20px">
              线下用途 <br>
            </div>
            <ul>
              <li v-for="vo in info.offlineUse.list" :key=" 'offline-use' + vo.name ">
                <div class="name">{{ vo.name }}</div>
                <div class="desc" v-html="vo.desc">{{ }}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="member-package-item">
          <div class="package-business package-item">
            <div class="title">
              <div class="name">{{ PERSON.INFO.LABEL }}</div>
              <div class="price __price-wrap">
                <span class="text-dollar">￥</span>
                <span class="text-price">{{ PERSON.MONTH.PRICE }}</span>
                <span class="text-year">/月起</span>
              </div>
              <div
                class="buy-btn"
                @click="buy(PERSON.MONTH)">立即开通
              </div>
            </div>
            <ul>
              <li
                v-for="(vo,idx) in [0,0,'普通下载','10张-海量/天',1,1,0,0,0,0,0,0,0,0,0,0,0]"
                :key="'package1'+idx">
                <i
                  v-if=" vo === 0 || vo=== 1"
                  class="iconfont"
                  :class="[ vo === 0 ? 'icon-cha2': 'icon-gou' ]"/>
                <span v-else>
                   {{ vo }}
                </span>
              </li>
            </ul>
          </div>
          <div class="package-business  package-item _hide">
            <div class="title">
              <div class="name">{{ BUSINESS_VIP_MONTH_INFO.NAME }}</div>
              <div class="price __price-wrap">
                <span class="text-dollar">￥</span>
                <span class="text-price">{{ BUSINESS_VIP_MONTH_INFO.PRICE }}</span>
                <span class="text-year">/月起</span>
              </div>
              <div class="buy-btn" @click="buy(BUSINESS_VIP_MONTH_INFO)">立即开通</div>
            </div>
            <ul>
              <li v-for="(vo,idx) in ['个人',1,'高速下载','10张-海量/天',1,1,1,1,1,1,1,1,0,0,0,0,0]" :key="'package1'+idx">
                <i
                  v-if=" vo === 0 || vo=== 1"
                  class="iconfont"
                  :class="[ vo === 0 ? 'icon-cha2': 'icon-gou' ]"/>
                <span v-else>
                  {{ vo }}
                </span>

              </li>
            </ul>
          </div>
          <div class="package-company package-item">
            <div class="title">
              <div class="name">{{ COMPANY_All_PURPOSE.NAME }}</div>
              <div class="price __price-wrap">
                <span class="text-dollar">￥</span>
                <span class="text-price">{{ COMPANY_All_PURPOSE.PRICE }}</span>
                <span class="text-year">/年起</span>
              </div>
              <div class="buy-btn" @click="buy(COMPANY_All_PURPOSE)">立即开通</div>
            </div>
            <ul>
              <li v-for="(vo,idx) in ['企业',1,'高速下载','200张-海量/年',1,1,1,1,1,1,1,1,1,1,1,1,1]" :key="'package2'+idx">
                <i
                  v-if=" vo === 0 || vo=== 1"
                  class="iconfont"
                  :class="[ vo === 0 ? 'icon-cha2': 'icon-gou' ]"/>
                <span v-else>
                  {{ vo }}
                </span>

              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {info} from "@/components/member/common/module";
import {
  BUSINESS_VIP_INFO, PERSON_VIP_INFO,

  PERSON_QUARTER_MONTH_INFO, BUSINESS_VIP_MONTH_INFO, PERSON_QUARTER_INFO,
} from "@/constant/VIP";
import {COMPANY_All_PURPOSE, COMPANY_ONLINE} from "@/constant/VIP_COMPANY";
import {VIP_MANAGE} from "@/constant/VIP_MANAGE";

const {PERSON} = VIP_MANAGE

export default {
  name: "AuthorizedScope",
  data() {
    return {
      info,
      BUSINESS_VIP_INFO, PERSON_VIP_INFO, PERSON_QUARTER_INFO,
      PERSON_QUARTER_MONTH_INFO,
      BUSINESS_VIP_MONTH_INFO,
      COMPANY_All_PURPOSE,
      PERSON
    }
  },
  methods: {
    buy(vipInfo) {
      this.$emit('buy', vipInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.authorized-scope {
  //height: 1783px;
  //height: 1439px;
  background: #F5F6FA;
  padding: 64px 0 72px;

  h2 {
    font-size: 36px;
    font-weight: bold;
    color: #2D2B33;
    line-height: 48px;
    letter-spacing: 1px;
    //margin-bottom: 160px;
    text-align: center;
  }

  .members-package {
    margin-top: 160px;
    display: flex;
    border-radius: 20px;
    border: 1px solid #ECEFF6;
    //overflow: hidden;
    box-shadow: 0px 0px 25px 0px rgba(0, 0, 26, 0.06);
    //margin: -114px auto 80px;
    width: 1200px;
    background-color: #fff;
    box-sizing: border-box;
    position: relative;

    .icon_vip-member {
      @include BgImage(554px, 119px, 'introduce/icon_vip-member.png');
      @include Position(1, 5, 56px, -84px);
      z-index: 2;
    }

    .authorization-scoped-wrap {
      width: 645px;
      /* 抽离公共代码 */
      .authorization-item {
        display: flex;
        border: 1px solid #ECEFF6;
        border-left: 0;
        box-sizing: border-box;
        border-top: 0;
        position: relative;
        z-index: 5;

        .title {
          width: 170px;
          border-right: 1px solid #ECEFF6;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          font-weight: bold;
          color: rgba(66, 72, 102, 0.85);
          text-align: center;

        }

        ul {
          flex: 1;

          li {
            //height: 84px;
            //height: 80px;
            padding: 18px 28px;
            box-sizing: border-box;
            border-bottom: 1px solid #ECEFF6;

            &:last-child {
              border-bottom: 0;
            }

            .name {
              font-size: 16px;
              font-weight: bold;
              color: #424866;
              line-height: 21px;
              margin-bottom: 4px;
            }

            .desc {
              font-size: 14px;
              color: #424866;
              line-height: 19px;
            }
          }
        }

        &:last-child {
          border-bottom: 0;
        }
      }

      .authorization-scoped {
        height: 95px;
        line-height: 95px;
        box-sizing: border-box;
        text-align: center;
        font-size: 22px;
        font-weight: bold;
        color: #424866;
        border-bottom: 1px solid #ECEFF6;
        border-right: 1px solid #ECEFF6;
        position: relative;
        z-index: 5;
        background-color: #FFFFFF;
        border-radius: 20px 0 0 0;
      }
    }

    .member-package-item {
      display: flex;
      //position: relative;
      //top: -97px;
      //z-index: 10;
      margin-top: -97px;
      background-color: #fff;
      border-radius: 20px 20px 0px 0px;
      //overflow: hidden;
      .package-item {
        width: 279px;

        .title {
          height: 192px;
          box-sizing: border-box;
          border-bottom: 1px solid #ECEFF6;
          border-right: 1px solid #ECEFF6;
          position: relative;

          @include LayoutFlex(2);

          .icon-prefs {
            @include Position(1, 5, 0, 0);
            width: 124px;
            height: 28px;
            background: linear-gradient(90deg, #FFD16C 0%, #FFAD63 100%);
            border-radius: 20px 0px 8px 0px;
            color: #FFFFFF;
            line-height: 28px;
            display: flex;
            align-items: center;
            font-size: 0;

            .icon_prefs {
              @include BgImage(15px, 15px, 'member/icon_prefs.png');
              margin: 0 4px 0 15px;

            }

            .icon-prefs-txt {
              font-size: 13px;
            }
          }

          .name {
            font-weight: bold;
            color: #0A2540;
            font-size: 20px;
            line-height: 27px;
          }

          .__price-wrap {
            font-size: 0;
            margin: 8px 0 10px 0;
            color: #596088;
            font-weight: bold;

            .text-dollar {
              font-size: 18px;
              line-height: 24px;
              color: #2D2B33;
              vertical-align: 2px;

            }

            .text-price {
              //letter-spacing: 1px;
              color: #2D2B33;
              margin: 0 4px;
              font-size: 36px;
              line-height: 48px;
            }

            .text-year {
              font-size: 18px;
              line-height: 24px;
              color: #2D2B33;
            }
          }

          .buy-btn {
            width: 180px;
            height: 48px;
            line-height: 48px;
            text-align: center;
            border-radius: 28px;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.3s ease-in;

            width: 148px;
            height: 42px;
            line-height: 42px;
            background: #35D0BA;
            border-radius: 28px;
          }

        }

        ul {
          border-right: 1px solid #ECEFF6;

          li {
            //height: 80px;
            height: 60px;
            box-sizing: border-box;
            border-bottom: 1px solid #ECEFF6;
            @include LayoutFlex(1);


            &:nth-child(8),
            &:nth-child(9),
            &:nth-child(10),
            &:nth-child(11),
            &:nth-child(12),
            &:nth-child(14),
            &:nth-child(16),
            {
              height: 79px;
            }

            &:nth-child(13),
            &:nth-child(15),
            {
              height: 117px;
            }

            .iconfont {
              font-size: 24px;
            }

            .icon-gou {
              color: #35D0BA;
            }

            .icon-cha2 {
              color: #A4A9BE;
            }

            &:last-child {
              border-bottom: 0;
            }

            span {
              font-size: 15px;
              color: #2D2B33;
              line-height: 20px;
            }
          }
        }

        &:first-child {
          ul {
            li {
              //border-right: 1px solid #ECEFF6;
            }
          }
        }

        &:last-child {
          .title {
            border-right: 0;
            //width: 261px;
            //background-color: #FFFFFF;
            position: relative;

            &:after {
              /*content: '';
              width: 10px;
              @include Position(1, 2, -1px, 0);
              bottom: 0;
              background-color: #FFFFFF;
              border-radius: 20px 20px 0px 0px;*/
            }
          }
        }

      }


      .package-business {
        .title {
          .name {
            color: #6969FF;
          }

          .buy-btn {
            background: #6969FF;
            color: #FFFFFF;
            @include ElementHover('', #5E5EE8);


          }
        }
      }

      .package-person {
        .title {
          .name {
            color: #35D0BA;
          }

          .buy-btn {
            color: #FFFFFF;
            //border: 1px solid #6969FF;
            @include ElementHover(#fff, #53D7C4);
          }
        }
      }

      .package-company {
        .title {
          .name {
            color: #233E90;
          }

          .buy-btn {
            color: #FFE198;
            background-color: #233E90;
            //border: 1px solid #6969FF;
            @include ElementHover(#FFE198, #435AA0);
          }

          .price {
            width: 100%;
            text-align: center;
            //margin: 18px auto;
            .text-price {
              /*font-size: 22px;
              font-weight: bold;
              color: #424866;
              line-height: 30px;*/
            }
          }
        }
      }
    }
  }
}
</style>
